import React from 'react';
import { Send, Mail, Linkedin, Twitter } from 'lucide-react';
import { siteContent } from '../mockData';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { contact, footer } = siteContent;
  const { t } = useTranslation();

  return (
    <footer id="contact" data-testid="footer-section" className="relative bg-[#F5B731] border-t border-[#F5C518]/50 py-16">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 mb-12">
          {/* Logo and Brand */}
          <div className="flex flex-col items-start space-y-0">
            <img
              src="https://customer-assets.emergentagent.com/job_cryptbr-promo/artifacts/445rsfvz_Logo%20Horizontal%20TRANSPARENTE.png"
              alt="CryPT-BR"
              className="h-[180px] md:h-[198px] w-auto cursor-pointer transform hover:scale-105 transition-transform duration-300"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} />
            <p className="text-sm font-bold !-mt-[75px] !mb-[0px] !ml-[9px] text-[#0D1F40]" style={{ fontFamily: "'Oxanium', sans-serif" }}>{t('footer.tagline')}</p>
          </div>

          {/* Contact Information */}
          <div className="!mt-[0px] !mb-[0px] !pl-[0px] !pr-[0px]">
            <h3 data-testid="footer-contact-title" className="text-[#0D1F40] text-2xl font-bold mb-6">{t('footer.contact')}</h3>
            <div className="space-y-4">
              <a
                href={contact.telegram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-telegram-link"
                className="flex items-center gap-3 text-[#0D1F40] hover:text-[#0A1628] transition-colors duration-200 group">
                <Send className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                <span>{t('footer.telegram')}</span>
              </a>
              <a
                href={`mailto:${contact.email}`}
                data-testid="footer-email-link"
                className="flex items-center gap-3 text-[#0D1F40] hover:text-[#0A1628] transition-colors duration-200 group">
                <Mail className="w-5 h-5 group-hover:scale-110 transition-transform" />
                <span>{contact.email}</span>
              </a>
              <a
                href={contact.linkedinPersonal}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin-link"
                className="flex items-center gap-3 text-[#0D1F40] hover:text-[#0A1628] transition-colors duration-200 group cursor-pointer"
              >
                <Linkedin className="w-5 h-5 group-hover:scale-110 transition-transform" />
                <span>{t('footer.linkedin')}</span>
              </a>
              <a
                href={contact.twitter}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-twitter-link"
                className="flex items-center gap-3 text-[#0D1F40] hover:text-[#0A1628] transition-colors duration-200 group cursor-pointer"
              >
                <Twitter className="w-5 h-5 group-hover:scale-110 transition-transform" />
                <span>X (Twitter)</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#1a2942] flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-gray-400 text-sm">
            &copy; {footer.year} &bull; cryptbr.com
          </div>
          <div className="flex gap-6 text-sm">
            {footer.links.map((link, index) =>
            <a
              key={index}
              href={link.url}
              className="text-gray-400 hover:text-[#00E5A0] transition-colors duration-200">
                {link.name}
              </a>
            )}
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;